import { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { formatDistanceToNow } from '../../../../../utils/format/formatDistanceToNow';
import { Checkbox } from '../../../../input/Checkbox';
import { Flex } from '../../../../layout/Flex';
import { MediaCover } from '../../../../media/MediaCover';
import { MediaPreview } from '../../../../posts/MediaPreview';
import { getContentIcon } from '../../../../posts/getContentIcon';
import { getSourceDisplayText } from '../../../../posts/getSourceDisplayText';
import { Typography } from '../../../../typography/Typography';
import { Column, DateColumn, Row } from '../../styles';
import { IconWrapper } from './styles';
import type { ContentPromotionPostsDialogRowProps } from './types';

export const ContentPromotionPostsDialogRow: React.FC<ContentPromotionPostsDialogRowProps> = ({
    post,
    selected,
    onSelect,
}) => {
    const onToggleSelected = useCallback(() => onSelect(!selected), [selected, onSelect]);
    const ContentIcon = getContentIcon(post.content);

    return (
        <Row pr={1}>
            <Column alignItems="center">
                <Checkbox checked={selected} onChange={onToggleSelected} />
            </Column>
            <Flex as={Link} to={post.url} position="relative" flexShrink={0} textDecoration="none">
                <MediaCover width={64} ratio={1} borderRadius={1} overflow="hidden">
                    <MediaPreview media={post.content[0]} namespace="grid" />
                </MediaCover>
                {ContentIcon ? (
                    <IconWrapper right={0.5} bottom={0.5}>
                        <ContentIcon color="var(--control-secondary-color)" size={20} />
                    </IconWrapper>
                ) : null}
            </Flex>
            <Column as={Link} to={post.url} textDecoration="none" flexGrow={1}>
                <Typography variant="caption" lines={2} wordBreak="break-word">
                    {post.text}
                </Typography>
                <Typography variant="caption" color="secondary">
                    {getSourceDisplayText(post.source)}
                </Typography>
            </Column>
            <DateColumn as={Link} to={post.url} textDecoration="none" alignSelf="stretch">
                <Typography textAlign="right" variant="caption">
                    {formatDistanceToNow(post.createdAt)}
                </Typography>
            </DateColumn>
        </Row>
    );
};
